var map = {
	"./afb-color.svg": 647,
	"./alb-color.svg": 648,
	"./all.svg": 649,
	"./amb-color.svg": 650,
	"./arg.svg": 651,
	"./aus.svg": 652,
	"./bank-icon.svg": 653,
	"./bankdemo-color.svg": 654,
	"./bel.svg": 655,
	"./bimb-color.svg": 656,
	"./bkr-color.svg": 657,
	"./bpay-color.svg": 658,
	"./bra.svg": 659,
	"./bsn-color.svg": 660,
	"./can.svg": 661,
	"./checked-white.png": 662,
	"./cimb-color.svg": 663,
	"./cimb-icon.svg": 664,
	"./citi-color.svg": 665,
	"./cmr.svg": 666,
	"./crc.svg": 667,
	"./cro.svg": 668,
	"./den.svg": 669,
	"./ecu.svg": 670,
	"./eng.svg": 671,
	"./esp.svg": 672,
	"./esports-active-m.svg": 673,
	"./esports-m.svg": 674,
	"./fav-gray.png": 675,
	"./fav-icon-active.png": 676,
	"./fav-icon.png": 677,
	"./fav-red.png": 678,
	"./fra.svg": 679,
	"./game-icon.svg": 680,
	"./games-active-m.svg": 681,
	"./games-m.svg": 682,
	"./ger.svg": 683,
	"./gha.svg": 684,
	"./gxbank-color.svg": 685,
	"./hlb-color.svg": 686,
	"./hlb-icon.svg": 687,
	"./hsbc-color.svg": 688,
	"./irn.svg": 689,
	"./jpn.svg": 690,
	"./kor.svg": 691,
	"./ksa.svg": 692,
	"./kwh-color.svg": 693,
	"./latest-icon-active.png": 694,
	"./latest-icon.png": 695,
	"./lc-active-m.svg": 696,
	"./lc-icon.svg": 697,
	"./lc-m.svg": 698,
	"./lottery-active-m.svg": 699,
	"./lottery-icon.svg": 700,
	"./lottery-m.svg": 701,
	"./love.svg": 702,
	"./mar.svg": 703,
	"./mbb-color.svg": 704,
	"./mex.svg": 705,
	"./ned.svg": 706,
	"./ocbc-color.svg": 707,
	"./ocbc-icon.svg": 708,
	"./p2p-active-m.svg": 709,
	"./p2p-icon.svg": 710,
	"./p2p-m.svg": 711,
	"./pbb-color.svg": 712,
	"./pol.svg": 713,
	"./por.svg": 714,
	"./price-high.svg": 715,
	"./price-low.svg": 716,
	"./qat.svg": 717,
	"./rhb-color.svg": 718,
	"./rhb-icon.svg": 719,
	"./scb-color.svg": 720,
	"./sen.svg": 721,
	"./slot-active-m.svg": 722,
	"./slot-icon.svg": 723,
	"./slot-m.svg": 724,
	"./speed-active-m.svg": 725,
	"./speed-m.svg": 726,
	"./sport-active-m.svg": 727,
	"./sport-m.svg": 728,
	"./sports-icon.svg": 729,
	"./square-icon.svg": 730,
	"./srb.svg": 731,
	"./star.svg": 732,
	"./sui.svg": 733,
	"./tng-color.svg": 734,
	"./trx-icon.svg": 735,
	"./trx.svg": 736,
	"./tun.svg": 737,
	"./uefa-icon.svg": 738,
	"./uob-color.svg": 739,
	"./uru.svg": 740,
	"./usa.svg": 741,
	"./usdc.svg": 742,
	"./usdt.svg": 743,
	"./ustd-icon.svg": 744,
	"./wal.svg": 745,
	"./x33-logo-b.svg": 746,
	"./x33-square-icon.svg": 747
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 80;